import { Col } from 'react-bootstrap';
import CustomSelect from '../../Reusable/CustomSelect';
import { rowsPerPageOptions } from '../../../constants/globals';

const AgGridFooter = (props) => {
  const { pageSize, t, onPageSizeChange } = props || {};

  return (
    <Col md={4} className="pr-0">
      <Col md={6} className="pr-0">
        <CustomSelect
          id={'rowsSize'}
          name={'rowsSize'}
          label={t?.rowsLabel}
          data={rowsPerPageOptions}
          textExtractor={(a) => a}
          valueExtractor={(a) => a}
          value={pageSize}
          onChange={onPageSizeChange}
          size={'small'}
          className={`font-size-14 smaller-input`}
        />
      </Col>
    </Col>
  );
};

export default AgGridFooter;
